// Форматирование для staff-админки (ANX-087).
export function formatRubMinor(minor: number): string {
  return new Intl.NumberFormat('ru-RU').format(Math.round(minor / 100)) + ' ₽';
}

export function formatDateShort(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString();
}
